/**
 * Utilidades de texto compartidas por los buscadores del panel (Productos
 * para profesional, Inventario, y cualquier otro que lo necesite).
 */

/**
 * Quita tildes y pasa a minúsculas, para que buscar "cafe" encuentre
 * "Café" y viceversa, sin depender de que la persona que busca escriba
 * el acento igual que el catálogo. Mismo criterio ya usado en
 * `Portal.tsx` (`esLineaPestanas()`) para comparar categorías de
 * servicio por nombre.
 */
export function normalizarBusqueda(texto: string): string {
  return texto
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
